export const AUDIT_LOG_PAGE_SIZE = 50;
export const AUDIT_LOG_MIN_SEARCH_LENGTH = 3;
export const AUDIT_LOG_SEARCH_DEBOUNCE_MS = 300;
// Must match the backend's SEARCHABLE_DATE_FORMAT ('%d %b %Y') so displayed and searched dates agree.
export const AUDIT_LOG_DATE_FORMAT = 'DD MMM YYYY';
export const AUDIT_LOG_TIME_FORMAT = 'HH:mm';

export type AuditActionTone =
  | 'success'
  | 'danger'
  | 'info'
  | 'neutral';

const AUDIT_ACTION_TONES: Record<string, AuditActionTone> = {
  file_uploaded: 'success',
  user_created: 'success',
  file_deleted: 'danger',
  user_deleted: 'danger',
  shared_basket_disabled: 'danger',
  user_permissions_updated: 'info',
  games_attached: 'info',
  games_detached: 'info',
  partners_attached: 'info',
  partners_detached: 'info',
  markets_attached: 'info',
  markets_detached: 'info',
};

export const getAuditActionTone = (action: string): AuditActionTone =>
  AUDIT_ACTION_TONES[action] ?? 'neutral';

export const getInitials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');
